/**
 * React Query infrastructure for the @wayak/ai package.
 *
 * This module provides:
 * - Centralized query key factory for cache invalidation
 * - Tiered timing constants based on data churn rate
 */

export { queryKeys } from "./keys";
export {
  HIGH_CHURN_STALE_TIME,
  MEDIUM_CHURN_STALE_TIME,
  LOW_CHURN_STALE_TIME,
  GC_TIME,
  // Legacy aliases
  STALE_TIME,
  REALTIME_STALE_TIME,
  LONG_STALE_TIME,
  THREAD_STALE_TIME,
} from "./config";
